import { Anchor, Text } from '@mantine/core'

import { Section } from '../../components/SectionHeader'
import { LegalPage } from './LegalPage'

/** `/terms`: no sign-in needed. The source text is also kept in docs/legal/terms.md; keep the two in sync. */
export function TermsPage() {
  return (
    <LegalPage title="Terms of service">
      <Text size="sm">
        These terms cover your use of Macrotide, a personal nutrition and training app from Ikaros Dev
        (macrotide@ikarosdev.com). By using the app you agree to them.
      </Text>

      <Section title="Not medical advice" card={false}>
        <Text size="sm">
          Macrotide and its AI features estimate nutrition and suggest training. They are not medical advice. Talk
          to a doctor, dietitian or qualified professional before making health decisions, especially around weight
          loss, injuries or medical conditions.
        </Text>
      </Section>

      <Section title="AI estimates can be wrong" card={false}>
        <Text size="sm">
          Nutrition read from a photo or description, and training plans adjusted by AI, are estimates. Check them
          before you rely on them. We work to make them accurate, but we can&apos;t guarantee it.
        </Text>
      </Section>

      <Section title="You're responsible for your inputs" card={false}>
        <Text size="sm">
          You&apos;re responsible for what you log, and what you confirm into your food log, recipes, programs and
          photos.
        </Text>
      </Section>

      <Section title="Age" card={false}>
        <Text size="sm">Macrotide is for people 18 and over.</Text>
      </Section>

      <Section title="Acceptable use" card={false}>
        <Text size="sm">Don&apos;t use Macrotide to break the law, interfere with the service, or access data that isn&apos;t yours.</Text>
      </Section>

      <Section title="Your content stays yours" card={false}>
        <Text size="sm">
          Food logs, recipes, photos and everything else you create stays yours. We only use it to provide the
          service, as described in our <Anchor href="/privacy">privacy policy</Anchor>.
        </Text>
      </Section>

      <Section title="Open data licences" card={false}>
        <Text size="sm">
          Macrotide&apos;s food and exercise data comes from several open sources, each under its own licence — see
          the About page in the app for the full list: Open Food Facts (ODbL), USDA FoodData Central, CoFID, CIQUAL,
          the Bundeslebensmittelschlüssel (BLS), MEXT, free-exercise-db and wger.
        </Text>
      </Section>

      <Section title="Deleting your account" card={false}>
        <Text size="sm">
          You can delete your account at any time — see <Anchor href="/delete-account">/delete-account</Anchor> for
          how, and what gets deleted.
        </Text>
      </Section>

      <Section title="No warranty, limited liability" card={false}>
        <Text size="sm">
          Macrotide is provided &quot;as is&quot;, without warranty of any kind. To the fullest extent the law
          allows, Ikaros Dev isn&apos;t liable for losses arising from your use of the app.
        </Text>
      </Section>

      <Section title="Governing law" card={false}>
        <Text size="sm">These terms are governed by the law of England and Wales.</Text>
      </Section>

      <Section title="Changes" card={false}>
        <Text size="sm">
          If we make a material change to these terms, we&apos;ll update the date above and tell you inside the app.
        </Text>
      </Section>

      <Section title="Contact" card={false}>
        <Text size="sm">macrotide@ikarosdev.com</Text>
      </Section>
    </LegalPage>
  )
}
